'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _availability = require('availability');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var i18n = {
    getLocale: function getLocale() {
        return 'en_US';
    },
    isRtlDir: function isRtlDir() {
        return false;
    },
    get: function get(token) {
        return token;
    }
};

var minuteOfDayToString = function minuteOfDayToString(minuteOfDay) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

    var hour = Math.floor(minuteOfDay / HOUR);
    var minute = minuteOfDay - hour * HOUR;
    if (hour >= 24) {
        hour -= 24;
    }

    var date = (0, _moment2.default)({
        year: 2000, M: 0, d: 1, hour: hour, minute: minute
    });

    return date.locale(locale).format('LT');
};

var dailyWindowToString = function dailyWindowToString(dailyWindow, i18n, renderer) {
    if (dailyWindow.durationMins === 24 * 60) {
        return renderer.getAllDayStr();
    }

    var locale = i18n.getLocale();

    var isRtl = i18n.isRtlDir ? i18n.isRtlDir() : i18n.getDir() === 'rtl';

    return !isRtl ? minuteOfDayToString(dailyWindow.minuteOfDay, locale) + renderer.getHoursDashDelimiter() + minuteOfDayToString(dailyWindow.minuteOfDay + dailyWindow.durationMins, locale) : minuteOfDayToString(dailyWindow.minuteOfDay + dailyWindow.durationMins, locale) + renderer.getHoursDashDelimiter() + minuteOfDayToString(dailyWindow.minuteOfDay, locale);
};

var HOUR = 60;
var DAY = HOUR * 24;

var getI18n = function getI18n(token, english) {
    if (!i18n) return english;
    try {
        var rc = i18n.get(token);
        return rc === token ? english : rc;
    } catch (e) {
        return english;
    }
};

var dailyWindowToKey = function dailyWindowToKey(dailyWindow) {
    return dailyWindow.minuteOfDay + '+' + dailyWindow.durationMins;
};
var dailyWindowsToKey = function dailyWindowsToKey(dailyWindows) {
    return _lodash2.default.map(dailyWindows, dailyWindowToKey).join('|');
};

var allWeek = [{
    days: [0, 1, 2, 3, 4, 5, 6],
    windows: [{
        minuteOfDay: 0,
        durationMins: DAY
    }]
}];

var allWeekNoGroup = [{
    days: [0],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}, {
    days: [1],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}, {
    days: [2],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}, {
    days: [3],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}, {
    days: [4],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}, {
    days: [5],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}, {
    days: [6],
    windows: [{
        minuteOfDay: 0,
        durationMins: 1440
    }]
}];

var prettyPrintWeekly = function prettyPrintWeekly(weekly, renderer, groupDays) {
    var humanizedWeekly = (0, _availability.humanizeWeekly)(weekly);
    var daysAndDailyWindowsList = (0, _lodash2.default)(humanizedWeekly).flatMap(function (daysAndDailyWindow) {
        return _lodash2.default.map(daysAndDailyWindow.days, function (day) {
            return {
                day: day,
                window: daysAndDailyWindow.window
            };
        });
    });

    if (groupDays) {
        daysAndDailyWindowsList = daysAndDailyWindowsList.groupBy('day');
    } else {
        daysAndDailyWindowsList = daysAndDailyWindowsList.map(function (i) {
            return [i];
        });
    }

    daysAndDailyWindowsList = daysAndDailyWindowsList.map(function (dayAndDailyWindows) {
        return {
            day: dayAndDailyWindows[0].day,
            windows: _lodash2.default.map(dayAndDailyWindows, function (dayAndDailyWindow) {
                return dayAndDailyWindow.window;
            })
        };
    });

    if (groupDays) {
        daysAndDailyWindowsList = daysAndDailyWindowsList.groupBy(function (dayAndDailyWindows) {
            return dailyWindowsToKey(dayAndDailyWindows.windows);
        });
    } else {
        daysAndDailyWindowsList = daysAndDailyWindowsList.map(function (i) {
            return [i];
        });
    }

    daysAndDailyWindowsList = daysAndDailyWindowsList.map(function (dayAndDailyWindows) {
        return {
            days: _lodash2.default.map(dayAndDailyWindows, 'day'),
            windows: dayAndDailyWindows[0].windows
        };
    }).value();

    var result = '';
    if (!_lodash2.default.isEqual(daysAndDailyWindowsList, groupDays ? allWeek : allWeekNoGroup)) {
        var firstPeriod = true;
        _lodash2.default.each(daysAndDailyWindowsList, function (daysAndDailyWindows) {
            if (!firstPeriod) {
                result += '___D___';
            }
            firstPeriod = false;

            result += renderer.getBlockStart(daysAndDailyWindows.days[0]);
            result += daysToString(daysAndDailyWindows.days, renderer);
            result += ' ' + renderer.getPeriodStart() + dailyWindowToString(daysAndDailyWindows.windows[0], i18n, renderer) + renderer.getPeriodEnd();
            for (var i = 1; i < daysAndDailyWindows.windows.length; ++i) {
                result += '___D___' + renderer.getPeriodStart() + dailyWindowToString(daysAndDailyWindows.windows[i], i18n, renderer) + renderer.getPeriodEnd();
            }
            result += renderer.getBlockEnd();
        });

        // Replace the period delimiters
        if (result.indexOf('___D___') > -1) {
            result = result.substring(0, result.lastIndexOf('___D___')) + (renderer.getPeriodLastDelimiter || renderer.getPeriodDelimiter)() + result.substring(result.lastIndexOf('___D___') + 7);

            result = result.replace(/___D___/g, renderer.getPeriodDelimiter());
        }
    }

    return result;
};

var prettyPrintExceptions = function prettyPrintExceptions() /*exceptions*/{
    // TODO: implement this
    return '';
};

var daysToString = function daysToString(days, renderer) {
    if (days.length === 7) {
        return renderer.getDaysStart() + renderer.getEverydayStr() + renderer.getDaysEnd();
    }

    var result = renderer.getDaysStart();

    var sessionStartIndex = 0;
    while (sessionStartIndex < days.length) {
        var sessionStartDay = days[sessionStartIndex];
        var sessionLength = 1;
        while (sessionStartIndex + sessionLength < days.length) {
            if (days[sessionStartIndex + sessionLength] !== sessionStartDay + sessionLength) {
                break;
            }
            ++sessionLength;
        }

        if (sessionStartIndex > 0) {
            result += ', ';
        }

        switch (sessionLength) {
            case 1:
                result += renderer.getDayToString(days[sessionStartIndex]);
                break;
            case 2:
                result += renderer.getDayToString(days[sessionStartIndex]) + ', ' + renderer.getDayToString(days[sessionStartIndex + sessionLength - 1]);
                break;
            default:
                result += renderer.getDayToString(days[sessionStartIndex]) + renderer.getDayDashDelimiter() + renderer.getDayToString(days[sessionStartIndex + sessionLength - 1]);
                break;
        }

        sessionStartIndex += sessionLength;
    }

    return result + renderer.getDaysEnd();
};

var AvailabilityPrinter = {
    init: function init(_ref) {
        var _i18n = _ref.i18n;

        i18n = _i18n;
    },
    prettyPrint: function prettyPrint(availability) {
        var renderer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var groupDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _lodash2.default.defaults(renderer, {
            getAlwaysStr: function getAlwaysStr() {
                return getI18n('availability_always', '24/7');
            },
            getExceptStr: function getExceptStr() {
                return ''; // Currently not implemented. getI18n('availability_except', 'Except');
            },
            getAllDayStr: function getAllDayStr() {
                return getI18n('availability_24hours', '24 hours');
            },
            getPeriodStart: function getPeriodStart() {
                return '';
            },
            getPeriodEnd: function getPeriodEnd() {
                return '';
            },
            getPeriodDelimiter: function getPeriodDelimiter() {
                return ', ';
            },
            getBlockStart: function getBlockStart() {
                return '';
            },
            getBlockEnd: function getBlockEnd() {
                return '';
            },
            getEverydayStr: function getEverydayStr() {
                return getI18n('availability_everydayofweek', 'Everyday');
            },
            getDayToString: function getDayToString(day) {
                switch (day) {
                    case 0:
                        return getI18n('availability_shortsunday', 'Sun');
                    case 1:
                        return getI18n('availability_shortmonday', 'Mon');
                    case 2:
                        return getI18n('availability_shorttuesday', 'Tue');
                    case 3:
                        return getI18n('availability_shortwednesday', 'Wed');
                    case 4:
                        return getI18n('availability_shortthursday', 'Thu');
                    case 5:
                        return getI18n('availability_shortfriday', 'Fri');
                    case 6:
                        return getI18n('availability_shortsaturday', 'Sat');
                    default:
                        throw new Error('illegal day: ' + day);
                }
            },
            getDayDashDelimiter: function getDayDashDelimiter() {
                return '-';
            },
            getDaysStart: function getDaysStart() {
                return '';
            },
            getDaysEnd: function getDaysEnd() {
                return '';
            },
            getHoursDashDelimiter: function getHoursDashDelimiter() {
                return '-';
            }
        });

        if (!availability) {
            availability = { weekly: [], exceptions: [] };
        }

        var weeklyStr = prettyPrintWeekly(availability.weekly, renderer, groupDays);
        var exceptionsStr = prettyPrintExceptions(availability.exceptions, renderer);

        var result = '';
        if (weeklyStr.length !== 0) {
            result += weeklyStr;
        } else {
            result += renderer.getAlwaysStr();
        }
        if (exceptionsStr.length !== 0) {
            result += ', ' + renderer.getExceptStr() + ' ' + exceptionsStr;
        }
        return result;
    }
};

exports.default = AvailabilityPrinter;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/AvailabilityPrinter.js
// module id = 270
// module chunks = 0